import { createSlice } from "@reduxjs/toolkit";

const mySlice = createSlice({
  name: "layout",
  initialState: {
    isNotify: false,
    isMenuOpen: false,
    notificationMsg: null,
    filterByCategory: null,
    filterByOrganisation: null,
    filterBySearch: null,
    filterByDate: null,
  },
  reducers: {
    setIsNotify(state, action) {
      state.isNotify = action.payload;
    },
    setNotificationMsg(state, action) {
      state.notificationMsg = action.payload;
    },
    setIsMenuOpen(state, action) {
      state.isMenuOpen = action.payload;
    },
    setFilterByCategory(state, action) {
      state.filterByCategory = action.payload;
    },
    setFilterByOrganisation(state, action) {
      state.filterByOrganisation = action.payload;
    },
    setFilterBySearch(state, action) {
      state.filterBySearch = action.payload;
    },
    setFilterByDate(state, action) {
      state.filterByDate = action.payload;
    },
  },
});

export const myLayoutActions = mySlice.actions;

export default mySlice.reducer;
